import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import "./App.css";
import { ThemeProvider } from "@mui/material";
import { SignIn } from "./pages/login";
import { SignUp } from "./pages/registration";
import { theme } from "./theme";
import { ForgotPassword, ResetPassword } from "./pages/forgot-password";
import { Main } from "./pages/main";
import { auth } from "service";
import { Provider } from "react-redux";
import store from "./redux";
import { AssignmentsRegistry } from "pages/assignments-registry";

const PrivateRoute = ({}) => {
  const isLoggedIn = auth.IsLoggedIn();
  if (!isLoggedIn) {
    return <Navigate to="/auth/signin" />;
  }
  return <Outlet />;
};

const PublicRoute = () => {
  const isLoggedIn = auth.IsLoggedIn();
  if (isLoggedIn) {
    return <Navigate to="/" />;
  }
  return <Outlet />;
};

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme()}>
        <Router basename={process.env.PUBLIC_URL}>
          <Routes>
            <Route element={<PrivateRoute />} path="/">
              <Route path="/" element={<Main />} />
              <Route
                path="/:user_type/assignments"
                element={<AssignmentsRegistry />}
              />
            </Route>
            <Route element={<PublicRoute />} path="/auth">
              <Route element={<SignIn />} path="/auth/signin" />
              <Route element={<SignUp />} path="/auth/signup" />
              <Route element={<ForgotPassword />} path="/auth/forgot" />
              <Route element={<ResetPassword />} path="/auth/reset/:token" />
            </Route>
          </Routes>
        </Router>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
